module.exports = __webpack_public_path__ + "./PaulPhoto_ec04eb39c12617da7c8d299d0dc946d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2020/PaulPhoto.png
// module id = 503
// module chunks = 0